import {SpaceTrSpace, Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import Container = Phaser.GameObjects.Container;
import {BattleLog} from "@/store/arena/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import TimeUtils from "@/utils/time-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArenaHistoryPanel extends Container {

    private readonly WIDTH: number = 550;
    private readonly FONT_STYLE: string = "italic";

    constructor(scene: Scene, canvas: HTMLCanvasElement, log: BattleLog, isEven: boolean) {
        super(scene);

        this.width = this.WIDTH * CU.S;
        this.height = 25 + 25 * CU.S;

        let y = 20 * CU.S;
        let x = 60;

        let currentPlayerWin = log.winByMe;

        let attackerNameText = '';
        let defenderNameText = '';
        let attackerActionText = '';
        let resultText = '';
        let resultColor = '';

        if (log.attackedByMe) {
            attackerNameText = Tr('vi');
            attackerActionText = Tr('brosili.vizov');
            defenderNameText = log.opponentName;
            resultText = currentPlayerWin ? Tr('pobedili.dot') : Tr('you.lost');
            resultColor = currentPlayerWin ? '#85ff85' : '#ff0909';

        } else {
            attackerNameText = log.opponentName;

            let actionByGender = log.opponentGender == "male" ? Tr('brosil') : SpaceTrSpace('challenged.female');
            attackerActionText = actionByGender + Tr('vizov');
            defenderNameText = Tr('vam');

            if (currentPlayerWin) {
                resultText = log.opponentGender == "male" ? Tr('proigral') : Tr('she.lost');

            } else {
                resultText = log.opponentGender == "male" ? Tr('pobedil') : Tr('she.won');
            }

            resultColor = currentPlayerWin ? '#85ff85' : '#ff0909';
        }

        // let cupImg = SpriteUtils.addImage(scene, x, y - 1, Keys.ARENA_CUP, undefined, 0.7);

        let rate = TextUtils.addTextAdvanced(this.scene, "", x! / CU.S, y,
            currentPlayerWin ? '#85ff85' : '#ff0909', 15, this.FONT_STYLE,  40, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let attackerName = TextUtils.addTextAdvanced(this.scene, attackerNameText, rate.getTopRight().x! / CU.S + 5, y,
            '#ffdfdf', 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let attackerAction = TextUtils.addTextAdvanced(this.scene, attackerActionText, attackerName.getTopRight().x! / CU.S + 5, y,
            '#ffdfdf', 15, this.FONT_STYLE, 200, 'left', 2, Fonts.MYRIADPRO_REGULAR);


        if (attackerName.getRightCenter().x! / CU.S > 400) {
            attackerAction.x = x - 10;
            attackerAction.y = attackerName.getBottomCenter().y! / CU.S + 15;
            this.height = 85;
        }

        let defenderName = TextUtils.addTextAdvanced(this.scene, defenderNameText, attackerAction.getTopRight().x! / CU.S + 5, attackerAction.getRightCenter().y! / CU.S,
            '#ffdfdf', 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        if (defenderName.getRightCenter().x! / CU.S > 400) {
            defenderName.x = x - 10;
            defenderName.y = attackerName.getBottomCenter().y! / CU.S + 15;
            this.height = 85;
        }

        let union = TextUtils.addTextAdvanced(this.scene, Tr('and'), defenderName.getTopRight().x! / CU.S + 5, defenderName.getRightCenter().y! / CU.S,
            '#ffdfdf', 15, this.FONT_STYLE, 15, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let result = TextUtils.addTextAdvanced(this.scene,  resultText, union.getTopRight().x! / CU.S + 5, union.getRightCenter().y! / CU.S,
            resultColor, 15, this.FONT_STYLE, 200, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let aftermath = TextUtils.addTextAdvanced(this.scene,  Tr('change.of.your.position') + ': ', x - 10,
            result.getBottomCenter().y! / CU.S + 10,
            '#ffdfdf', 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        // let cupImg2 = SpriteUtils.addImage(scene, aftermath.getTopRight().x! / CU.S + 22, aftermath.y / CU.S - 1, Keys.ARENA_CUP, undefined, 0.7);

        let positionWas = log.myPosition;
        let positionNow = positionWas;
        if(log.attackedByMe && log.winByMe && log.oppPosition < log.myPosition){
            positionNow = log.oppPosition;
        } else  if (!log.attackedByMe && !log.winByMe && log.oppPosition > log.myPosition){
            positionNow = log.oppPosition;
        }

        let positionChange = positionWas + ' -> ' + positionNow;
        let aftermathAmount = TextUtils.addTextAdvanced(this.scene,  positionChange, aftermath.getBottomRight().x! / CU.S + 5, result.getBottomCenter().y! / CU.S + 10,
            resultColor, 15, this.FONT_STYLE, 500, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        let t1 = TimeUtils.getServerTimeMs();
        let t2 = new Date(log.completedAt).valueOf();
        let diff = t1 - t2;
        let ours = Math.floor(diff / 3600000);
        let mins = Math.floor((diff % 3600000) / 60000);

        let time = TextUtils.addTextAdvanced(this.scene,  "(" + ours.toString() + Tr('hour.dot') + mins.toString() + Tr('minute.dot') +  ")", aftermathAmount.getBottomRight().x! / CU.S + 5,
            result.getBottomCenter().y! / CU.S + 10, '#ffdfdf', 15, this.FONT_STYLE, 120, 'left', 2, Fonts.MYRIADPRO_REGULAR);

        this.add([rate, attackerName, attackerAction, defenderName, union, result, aftermath, aftermathAmount, time]);

    }

}
